import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function BrandHandMarkTwoLinesVariant4(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="148"
            height="8"
            viewBox="0 0 148 8"
            fill="currentColor"
            {...props}
        >
            <path d="M136.049 0.00733388C136.69 0.488536 136.013 0.699788 135.479 0.770208C134.172 0.934521 132.604 0.688052 131.237 0.770208C109.877 2.1434 88.1964 -0.121766 66.9314 3.88043L58.5799 5.71134C61.4429 5.46487 64.3772 5.52355 67.2403 5.33576C80.4745 4.45551 93.6731 2.90628 106.931 2.65981C118.3 2.44855 132.342 2.31945 143.581 3.03539C144.733 3.10581 147.347 3.24666 148 4.18559C137.938 3.58702 127.828 3.80999 117.73 3.82172C100.718 3.8452 85.381 4.90152 68.4046 6.08692C63.6051 6.42728 58.758 6.56812 53.9586 6.8498C53.816 6.18081 54.1249 6.08692 54.6238 5.79351C55.7881 5.11278 59.7322 4.32643 61.2766 3.9978C65.5415 3.08234 70.0202 2.50724 74.3801 2.28424L71.0894 1.89693L5.39347 6.09863L10.787 7.06105L11.5473 8C10.193 7.36622 -0.0118695 7.09628 1.03641e-05 5.91088C1.03641e-05 5.35926 1.29492 5.34752 1.71072 5.32405C3.82535 5.17147 6.13005 5.46486 8.28031 5.33576C44.2646 3.2349 80.1181 -0.34476 116.186 0.0308122C122.803 0.101232 129.432 -0.0513558 136.049 0.0190641V0.00733388Z" />
        </svg>
    );
}
